import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=f2b6376c&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Lang\\pCloudSync\\mats\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b6376c')) {
      api.createRecord('f2b6376c', component.options)
    } else {
      api.reload('f2b6376c', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=f2b6376c&", function () {
      api.rerender('f2b6376c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Home.vue"
export default component.exports